import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Navbar from '../components/Navbar';
import { useState } from 'react';
import SidebarDashboard from '../components/SidebarDashboard';
import {MainContainer, BorderContainer } from '../components/UserDashboard/DashboardComponents';
import Footer from '../components/Footer';


const TradingComp = () => {

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
    };
    
    return (
        <>
        <ScrollToTop />
        <SidebarDashboard isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>
        <div style={{background: "black", height: "80px", width: "100%"}} />
        <MainContainer style={{backgroundColor: "black", textAlign: "center"}}>
            <BorderContainer>
                <h2>
                    Sample Text
                </h2>
            </BorderContainer>
        </MainContainer>
        <Footer />
        </>
    )
}

export default TradingComp